export const SEARCH_DOCTORS = "SEARCH_DOCTORS";
